/**
 * This function recieves a solidity file
 * content ahnd returns the file's contract
 * @param {String} fileContent - A solidity file content.
 */
export default function (fileContent) {
  let fileContract
  if (!fileContent) return
  fileContent?.replace(/^\s*contract ([a-zA-Z0-9]+)/gm, (m, contractName) => {
    fileContract = contractName
    return ""
  })
  return fileContract
}

/**
 * This function recieves a solidity file
 * content and returns all the contracts in the file.
 * @param {String} fileContent - A solidity file content.
 * @returns {Object}
 */
export function getFileContracts(fileContent) {
  const fileContracts = []
  const fileContractsObj = {}
  fileContent?.replace(/^\s*contract ([a-zA-Z0-9_]+)/gm, (m, contractName) => {
    fileContracts.push(contractName)
    fileContractsObj[contractName] = true
    return ""
  })
  return { asArray: fileContracts, asObject: fileContractsObj }
}
